import Model from '@/models/Model'

export default class PchPurchaseInvoice extends Model {

  /**
   * 
   */  
  get pch_payment_condition_type() {
    return this.pch_payment_condition ? this.pch_payment_condition.type : '-'
  }

  /**
   * 
   */
  get pch_provider_rut() {
    return this.pch_provider ? this.pch_provider.rut : '-'
  }

  /**
   * 
   */
  get pch_provider_alias_name() {
    return this.pch_provider ? this.pch_provider.alias_name : '-'
  }

  /**
   * 
   */
  resource() {
    return 'pch_purchase_invoice'
  }
}